<template>
    <div class="c-textarea" v-bind:class="wrapClass">
        <span class="input-group-addon" v-if="!isVertical && ( hasLabel || icon.length>0)">
            <span class="gray">{{label}}</span></span>
        <div class="fg-line">
            <div class="guidance-editor">
                <div class="toolbar" v-bind:disabled="!isEnabled">
                    <slot name="toolbar"></slot>
                </div>
                <div class="editarea" v-bind:style="{height: controlHeight}">
                    <textarea class="codable" v-bind:value="value" v-on:input="updateValue($event.target.value)" v-bind:placeholder="placeholder" v-on:focus="_p_focus"
                        v-on:blur="_p_blur" v-bind:disabled="!isEnabled"></textarea>
                </div>

            </div>
            <label v-if="isVertical" style="margin-top: -22px;" class="fg-label">{{label}}</label>
        </div>
    </div>
</template>

<script>
    import vue from 'vue'
    import mixins from '../../mixins/control-mixins'
    import expression from 'helpers/expression'
    var vm = function () {
        return {
            ifocus: false,
        };
    };

    export default {
        name:'c-textarea',
        mixins: [mixins],
        data: vm,
        props: {
            value: {
                required: true,
                default: function () {
                    return '';
                }
            },
            controlHeight: {
                type: String,
                default: function () {
                    return "80px";
                }
            }
        },
        computed: {
            wrapClass(){
                return {
                    'form-group fg-float m-t-20':this.isVertical ,
                    'input-group':!this.isVertical && this.hasLabel,
                }
            },
            hasLabel(){
                return this.label && this.label.length>0;
            },
        },
        mounted: function () {
            if ($(this.$el).find(".toolbar").children().length <= 0) {
                $(this.$el).find(".toolbar").css("display", "none").css("height", "0px");
            }
            $(this.$el).find(".statusbar").mousedown(function (e) {
                var disabled = $(this).attr("disabled");
                if (disabled != undefined && disabled != false) return;
                var disY = (e || event).clientY;
                var toolsHeight = 0;
                if ($(this).parent().children(".toolbar").children().length > 0) {
                    var height = $(this).parent().children(".toolbar").css("height");
                    toolsHeight = parseInt(height.substring(0, height.indexOf('p')));
                }
                this.top = this.offsetTop - toolsHeight;
                var line = this;
                var editArea = $(this).parent().children(".editarea");
                document.onmousemove = function (e) {
                    var iT = line.top + ((e || event).clientY - disY);
                    iT < 45 && (iT = 45);
                    editArea.css("height", iT + "px");
                    return false;
                };
                document.onmouseup = function () {
                    document.onmousemove = null;
                    document.onmouseup = null;
                    line.releaseCapture && line.releaseCapture();
                };
                line.setCapture && line.setCapture();
                return false;
            });
        },
        methods: {
            _p_focus: function (e) {
                this.ifocus = true;
                this.$emit('focus', arguments);
            },
            _p_blur: function (e) {
                this.ifocus = false;
                this.$emit('blur', arguments);

            },
            updateValue: function (value) {
                this.$emit('input', value);
            }
        }
    };

</script>
<style lang="less" rel="stylesheet/less">
    .c-textarea{
        margin-top: 5px;
    }
    .guidance-editor{
        .toolbar{
            padding:5px 10px;
        }
    }
</style>




// WEBPACK FOOTER //
// textarea.vue?1e5559a6